import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=614b69bc&scoped=true&lang=pug&"
import script from "./Contact.vue?vue&type=script&lang=js&"
export * from "./Contact.vue?vue&type=script&lang=js&"
import style0 from "./Contact.vue?vue&type=style&index=0&id=614b69bc&lang=scss&scoped=true&"
import style1 from "./Contact.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614b69bc",
  null
  
)

export default component.exports